import React from 'react';
import styled from 'styled-components';
import webLinkIcon from '../../static/image/icon_weblink_red.svg';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const ExternalLink = ({ children, ...props }: Props): JSX.Element => {
  return (
    <StyledLink target="_blank" rel="noopener noreferrer" {...props}>
      {children}
      <Icon src={webLinkIcon} alt="external link icon" />
    </StyledLink>
  );
};

const StyledLink = styled.a`
  display: inline-flex;
  gap: 0.25em;
  color: #eb0000;
  text-decoration: none;
  font-size: inherit;
  cursor: pointer;

  &:hover,
  &:active {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid #8d8d8d;
    outline-offset: 2px;
  }

  &:visited {
    color: #eb0000;
  }
`;

const Icon = styled.img`
  width: 1em; /* 文字サイズに合わせる */
  height: 1em; /* 文字サイズに合わせる */
  margin-right: 0.25em;
  vertical-align: middle;
  object-fit: contain;
  flex-shrink: 0;
`;
